import { useMemo, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import Modal from '../../../../components/Modal';
import { showModal } from '../../../../store/actions/modal';
import Link from '../../../../components/Link';
import constants from '../../../../constants';
import {
  ModalLabel,
  ModalTitle,
  ModalMessage,
  ModalActions
} from './styles';

interface ComponentProps {
  expertInformation;
  visibleModal?: string | null;
}

const Component = ({
  expertInformation,
  visibleModal,
}: ComponentProps) => {
  const dispatch = useDispatch();

  const isMoraLevelTwo = useMemo(() => {
    return expertInformation?.delinquency === "Level_2";
  }, [expertInformation?.delinquency])

  // Mostrar el modal automáticamente si el experto está en mora nivel 2
  useEffect(() => {
    if (isMoraLevelTwo) {
      dispatch(showModal('mora-level-two-dashboard'));
    }
  }, [isMoraLevelTwo, dispatch]);

  if (!isMoraLevelTwo) {
    return <></>;
  }

  const supportUrl = `${constants.whatsapp.url}?phone=${constants.whatsapp.number}&text=${encodeURIComponent('Hola, necesito ayuda con mi cuenta que adeuda múltiples comisiones pendientes.')}`;

  return (
    <Modal
      name="mora-level-two-dashboard"
      visibleModal={visibleModal}
      showClose={false}
      disableBackdropClose={true}
      width="520"
      styles={{
        animationStyles: {
          backdropFilter: 'blur(5px)',
          backgroundColor: 'rgba(0, 0, 0, .4)',
        },
        modalContent: {
          padding: '28px',
        },
        modalHeader: {
          padding: 0,
        }
      }}
    >
      <ModalLabel>Es necesario actuar</ModalLabel>
      <ModalTitle>⚠️ Necesitamos que regularices tu cuenta</ModalTitle>
      <ModalMessage>
        <p>
          <strong>Tu cuenta adeuda múltiples comisiones pendientes.</strong> Para continuar usando Klouser, necesitás regularizar tu situación. Una vez confirmado el pago, vas a poder seguir usando todas las funcionalidades.
        </p>
        <p>
          ¿Tenés dudas sobre los montos o cómo proceder? Contactá a soporte, estamos para ayudarte.
        </p>
      </ModalMessage>
      <ModalActions>
        <Link
          href={supportUrl}
          target="_blank"
          options={{ skin: 'purple', size: 'lg', type: 'filled', native: false }}
          style={{ minWidth: '150px' }}
        >
          Contactar soporte
        </Link>
      </ModalActions>
    </Modal>
  )
}

const state = ({ userStore, modalStore }) => {
  const { data: user } = userStore.information;
  const { visibleModal } = modalStore;

  return {
    expertInformation: user?.expert,
    visibleModal,
  };
};

export default connect(state)(Component);

